export default {
  BT_HDP: "Handicap | HDP",
  BT_OU: "Over/Under | O/U",
  BT_ML: "Moneyline",
  BT_1X2: "1X2",
  BT_1X2HDP: "3 Way Handicap",
  BT_CS: "Correct Score",
  BT_OE: "Odd/Even | O/E",
  BT_DC: "Double Chance",
  BT_HTFT: "Half Time/Full Time",
  BT_FGLG: "First Goal/Last Goal",
  BT_TG: "Total Goal",
  BT_OR: "Outright",
  BT_ORZ: "Outright",

  BT_ANB: "Away No Bet",
  BT_BS: "Both/One/Neither Team To Score",
  BT_CL: "Clean Sheet",
  BT_DNB: "Draw No Bet",
  BT_DNBH: "HT. Draw No Bet",
  BT_HNB: "Home No Bet",
  BT_TWTN: "To Win To Nil",

  BT_HDPF: "FT. Handicap | FT. HDP",
  BT_OUF: "FT. Over/Under | FT. O/U",
  BT_MLF: "FT. Moneyline | FT. ML",
  BT_1X2F: "FT. 1X2",
  BT_1X2HDPF: "FT. 3 Way Handicap",
  BT_CSF: "FT. Correct Score",
  BT_OEF: "FT. Odd/Even | FT. O/E",
  BT_DCF: "FT. Double Chance",
  BT_FGLGF: "FT. First Goal/Last Goal",
  BT_TGF: "FT. Total Goal",

  BT_HDPH: "HT. Handicap | HT. HDP",
  BT_OUH: "HT. Over/Under | HT. O/U",
  BT_MLH: "HT. Moneyline | HT. ML",
  BT_1X2H: "HT. 1X2",
  BT_1X2HDPH: "HT. 3 Way Handicap",
  BT_CSH: "HT. Correct Score",
  BT_OEH: "HT. Odd/Even | HT. O/E",
  BT_DCH: "HT. Double Chance",
  BT_FGLGH: "HT. First Goal/Last Goal",
  BT_TGH: "HT. Total Goal",
  BT_O: "Over",
  BT_U: "Under",
  BT_ODD: "Odd",
  BT_EVEN: "Even",

  BT_HDPOU: "HDP & OU",
  BT_PARLAY: "Mix Parlay",
  BT_FT: "FT. ",
  BT_1H: "HT. ",
  BT_2H: "2H. ",

  BT_FG: "First Goal",
  BT_LG: "Last Goal",
  BT_HFG: "HFG",
  BT_AFG: "AFG",
  BT_HLG: "HLG",
  BT_ALG: "ALG",
  BT_NG: "No Goal",
  BT_HY: "Home Yes",
  BT_HN: "Home No",
  BT_AY: "Away Yes",
  BT_AN: "Away No",
  BT_H: "Home",
  BT_A: "Away",
  BT_D: "Draw",
  BT_HD_DC: "HD",
  BT_HA_DC: "HA",
  BT_DA_DC: "DA",
  BT_HH: "HH",
  BT_HD: "HD",
  BT_HA: "HA",
  BT_DH: "DH",
  BT_DD: "DD",
  BT_DA: "DA",
  BT_AH: "AH",
  BT_AD: "AD",
  BT_AA: "AA",

  BT_Y: "Yes",
  BT_N: "No",

  BT_LIVE: "LIVE",
  BT_HT: "H.TIME",
  BT_DELAYED: "DELAY",
  BT_PEN: "PEN",

  BT_FT1: "FT.1",
  BT_FT2: "FT.2",
  BT_FTX: "FT.X",
  BT_HT1: "HT.1",
  BT_HT2: "HT.2",
  BT_HTX: "HT.X",

  BT_BOTH: "Both",
  BT_ONE: "One",

  BS_HDP: "FT Handicap",
  BS_HDPH: "HT. Handicap",
  BS_OU: "FT Over/Under",
  BS_OUH: "HT. Over/Under",
  BS_OE: "FT Odd/Even",
  BS_OEH: "HT. Odd/Even",
  BS_1X2: "FT 1X2",
  BS_1X2H: "HT. 1X2",
  BS_ML: "FT Moneyline",
  BS_MLH: "HT. Moneyline",
  BS_1X2HDP: "FT 3 Way HDP",
  BS_1X2HDPH: "HT. 3 Way HDP",
  BS_CS: "FT Correct Score",
  BS_CSH: "HT. Correct Score",
  BS_DC: "FT Double Chance",
  BS_DCH: "HT. Double Chance",
  BS_FGLG: "FT First/Last Goal",
  BS_FGLGH: "HT. First/Last Goal",
  BS_TG: "FT Total Goal",
  BS_TGH: "HT. Total Goal",
  BS_ANB: "Away No Bet",
  BS_HTFT: "Half/Full Time",
  BS_BS: "B/O/N Team To Score",
  BS_CL: "Clean Sheet",
  BS_DNB: "Draw No Bet",
  BS_DNBH: "HT. Draw No Bet",
  BS_HNB: "Home No Bet",
  BS_TWTN: "To Win To Nil",
  BS_OR: "Outright",
  BS_ORZ: "Outright",

  LOT_BS: "B/S",
  LOT_BIG: "B",
  LOT_SMALL: "S",
  LOT_OE: "O/E",
  LOT_ODD: "O",
  LOT_EVEN: "E",
  LOT_OU: "O/U",
  LOT_OVER: "O",
  LOT_UNDER: "U",
  LOT_FT: "FT",
  LOT_HT: "HT",

  BT_ALLBT: "All Bet Type",

  D_1: "Single Number",
  D_2: "Number & Reverse",
  D_3: "Box",
  D_4: "iBox",
  D_5: "Box Last 3 Digit",
  D_6: "Box Last 2 Digit",

  D_BIG: "BIG",
  D_SMALL: "SMALL",
  D_AA: "AA",
  D_SA: "3A",
  D_SB: "B",
  D_SC: "C",
  D_SD: "D",
  D_SE: "E",
  D_ABC: "3C",

  LOT_1: "H",
  LOT_0: "A",

  BT_KO: "K.O. By",

  ODD_Home: "H",
  ODD_Away: "A",
  ODD_Draw: "D",
  ODD_Over: "O",
  ODD_Under: "U",
  ODD_Odd: "O",
  ODD_Even: "E",

  GH_1X2: "WIN",
  GH_1X20: "WIN",
  GH_1X2HDP: "PLACE/SHOW",
  GH_1X2HDP2: "PLACE",
  GH_1X2HDP4: "SHOW",
  GH_OVER: "OVER (4,5,6)",
  GH_UNDER: "UNDER (1,2,3)",
  GH_ODD: "ODD (1,3,5)",
  GH_EVEN: "EVEN (2,4,6)",
  GH_OU1: "OVER (4,5,6)",
  GH_OU2: "UNDER (1,2,3)",
  GH_OE1: "ODD (1,3,5)",
  GH_OE2: "EVEN (2,4,6)",

  GX_1X2: "WIN",
  GX_1X20: "WIN",
  GX_1X2HDP: "PLACE/SHOW",
  GX_1X2HDP2: "PLACE",
  GX_1X2HDP4: "SHOW",
  GX_OVER: "OVER (7-12)",
  GX_UNDER: "UNDER (1-6)",
  GX_ODD: "ODD (1,3,5,7,9,11)",
  GX_EVEN: "EVEN (2,4,6,8,10,12)",
  GX_OU1: "OVER (7-12)",
  GX_OU2: "UNDER (1-6)",
  GX_OE1: "ODD (1,3,5,7,9,11)",
  GX_OE2: "EVEN (2,4,6,8,10,12)",

  GC_OU: "O/U",
  GC_OE: "O/E",
  GC_OVER: "OVER (3,4,5)",
  GC_UNDER: "UNDER (0,1,2)",
  GC_ODD: "ODD (1,3,5)",
  GC_EVEN: "EVEN (0,2,4)",
  GC_5_0: "5-0",
  GC_4_1: "4-1",
  GC_3_2: "3-2",
  GC_0_5: "0-5",
  GC_1_4: "1-4",
  GC_2_3: "2-3",
  GC_ML0: "1ST BALL",
  GC_1X20: "TO WIN",
  GC_ML: "1ST BALL",
  GC_1X2: "TO WIN",
  GC_OU1: "OVER (3,4,5)",
  GC_OU2: "UNDER (0,1,2)",
  GC_OE1: "ODD (1,3,5)",
  GC_OE2: "EVEN (0,2,4)",


  GR_RED: "RED",
  GR_YELLOW: "YELLOW",
  GR_BLUE: "BLUE",
  GR_GREEN: "GREEN",
  GR_OVER: "OVER (3,4)",
  GR_UNDER: "UNDER (1,2)",
  GR_ODD: "ODD (1,3)",
  GR_EVEN: "EVEN (2,4)",
  GR_SINGLE: "SINGLE",
  GR_PAIR: "PAIR",
  GR_TRIPS: "TRIPS",
  GR_ADVANCED: "ADVANCED",
  GR_ELIMINATED: "ELIMINATED",
  GR_HIT1: "HIT 1",
  GR_HIT2: "HIT 2",
  GR_PERFECT: "PERFECT",
  GR_MLHOME: "ADVANCED",
  GR_MLAWAY: "ELIMINATED",
  GR_1X2FT1: "SINGLE",
  GR_1X2FTX: "PAIR",
  GR_1X2FT2: "TRIPS",
  GR_ML1: "ADVANCED",
  GR_ML2: "ELIMINATED",
  GR_1X21: "SINGLE",
  GR_1X22: "TRIPS",
  GR_1X23: "PAIR",
  GR_OU1: "OVER (3,4)",
  GR_OU2: "UNDER (1,2)",
  GR_OE1: "ODD (1,3)",
  GR_OE2: "EVEN (2,4)",

  ROOM_A: "Open",
  ROOM_0: "Active",
  ROOM_1: "Closed",
  ROOM_2: "Cancel",
  ROOM_3: "Ended",
  ROOM_4: "Stop Betting",
  ROOM_10: "All",

  ROOM_T0: "All",
  ROOM_T1: "Public Room",
  ROOM_T2: "Private Room",
  ROOM_T3: "Play to Earn",

  joinRoom1: "Join Public Room",
  joinRoom2: "Join Private Room",
  joinRoom3: "Join Play Room",
  createRoom1: "Create Public Room",
  createRoom2: "Create Private Room",
  createRoom3: "Create Play Room",
  Champion: "Champion",
  FirstRunnerUp: "First Runner Up",
  SecondRunnerUp: "Second Runner Up",

  BT_OEHM: "Home Odd/Even | Home O/E",
  BT_OEHMH: "FH. Home Odd/Even | FH. Home O/E",
  BT_OEAW: "Away Odd/Even | Away O/E",
  BT_OEAWH: "FH. Away Odd/Even | FH. Away O/E",

  BS_OEHM: "FT. Home Odd/Even | FT. Home O/E",
  BS_OEHMH: "FH. Home Odd/Even | FH. Home O/E",
  BS_OEAW: "FT. Away Odd/Even | FT. Away O/E",
  BS_OEAWH: "FH. Away Odd/Even | FH. Away O/E",

  MB_OVER: "OVER (4,5,6)",
  MB_UNDER: "UNDER (1,2,3)",
  MB_ODD: "ODD (1,3,5)",
  MB_EVEN: "EVEN (2,4,6)",

  BS_1X2OU: "1X2 + OU",
  BT_1X2OU: "1X2 + OU",
  BT_1O: "1O",
  BT_1U: "1U",
  BT_2O: "2O",
  BT_2U: "2U",
  BT_XO: "XO",
  BT_XU: "XU",

  BS_DCOU: "Double Chance + OU",
  BT_DCOU: "Double Chance + OU",
  BT_HDO: "HDO",
  BT_HDU: "HDU",
  BT_HAO: "HAO",
  BT_HAU: "HAU",
  BT_DAO: "DAO",
  BT_DAU: "DAU",

  BS_OUOE: "OU + OE",
  BT_OUOE: "OU + OE",
  BK_OO: "OO",
  BK_OE: "OE",
  BK_UO: "UO",
  BK_UE: "UE",

  BS_HTFTOE: "HT/FT + OE",
  BT_HTFTOE: "HT/FT + OE",
  BK_EO: "EO",
  BK_EE: "EE",

  BS_WM: "Winning Margin",
  BT_WM: "Winning Margin",
  BK_H1: "Home 1",
  BK_H2: "Home 2",
  BK_H3Up: "Home 3+",
  BK_A1: "Away 1",
  BK_A2: "Away 2",
  BK_A3Up: "Away 3+",
  BK_D: "Score Draw (Excl. 0-0)",
  BK_NG: "No Goal",

  BS_ETG: "Exact Total Goal",
  BT_ETG: "Exact Total Goal",
  BS_EHTG: "Exact Home Total Goal",
  BT_EHTG: "Exact Home Total Goal",
  BS_EATG: "Exact Away Total Goal",
  BT_EATG: "Exact Away Total Goal",
  BS_ETGH: "FH. Exact Total Goal",
  BT_ETGH: "FH. Exact Total Goal",
  BS_EHTGH: "FH. Exact Home Total Goal",
  BT_EHTGH: "FH. Exact Home Total Goal",
  BS_EATGH: "FH. Exact Away Total Goal",
  BT_EATGH: "FH. Exact Away Total Goal",
  BT_0: "0",
  BT_1: "1",
  BT_2: "2",
  BT_3: "3",
  BT_4: "4",
  BT_5: "5",
  BT_6Up: "6+",
  BT_3Up: "3+",

  BT_CSHTFT: "HT/FT Correct Score",
  BS_CSHTFT: "HT/FT Correct Score",
  BT_ETGHTFT: "HT/FT Exact Total Goal",
  BS_ETGHTFT: "HT/FT Exact Total Goal",

  CF_CS_2_1: "2-1",
  CF_CS_2_0: "2-0",
  CF_CS_0_2: "0-2",
  CF_CS_1_2: "1-2",
  CF_R_1_W: "ROUND 1 WINNERS",
  CF_R_2_W: "ROUND 2 WINNERS",
  CF_R_3_W: "ROUND 3 WINNERS",
  CF_MLHOME: "HOME WIN",
  CF_MLAWAY: "AWAY WIN",
  CF_EVEN: "2 ROUNDS GAME",
  CF_ODD: "3 ROUNDS GAME",
  CF_ML1: "HOME WIN",
  CF_ML2: "AWAY WIN",
  CF_ML: "Money Line",
  CF_CS: "Correct Score",
  CF_OE: "Odd/Even",
  CF_0: "R",
  CF_1: "H",
  CF_2: "A",
  CF_OE1: "Odd",
  CF_OE2: "Even",

  MA_CS_3_0: "3-0",
  MA_CS_2_1: "2-1",
  MA_CS_0_3: "0-3",
  MA_CS_1_2: "1-2",
  MA_ML_TW: "TEAM WIN",
  MA_O: "OVER",
  MA_U: "UNDER",
  MA_OE1: "Odd",
  MA_OE2: "Even",
  MA_ML: "Money Line",
  MA_CS: "Correct Score",
  MA_OU: "Over/Under",
  MA_OE: "Odd/Even",
  MA_R_1_W: "ROUND 1 WINNER",
  MA_R_2_W: "ROUND 2 WINNER",
  MA_R_3_W: "ROUND 3 WINNER",
  MA_T_3_R: "TOTAL 3 ROUNDS",
  MA_ANY_W_R: "ANY WIN ROUNDS",
  MA_NO_W_R: "NO WIN ROUNDS",
  MA_W_1: "WIN 1",
  MA_W_2: "WIN 2",
  MA_PF: "PERFECT",
  MA_OU1: "OVER",
  MA_OU2: "UNDER",
  MA_ML1: "HOME WIN",
  MA_ML2: "AWAY WIN",
  MA_ML_C_1: "ANY WIN ROUNDS",
  MA_ML_C_2: "NO WIN ROUNDS",

  EF8_R1_1STBOOM: "ROUND 1 1ST BOOM",
  EF8_R2_1STBOOM: "ROUND 2 1ST BOOM",
  EF8_R3_1STBOOM: "ROUND 3 1ST BOOM",
  EF8_0: "-",
  EF8_1: "H",
  EF8_2: "A",

};